import React from "react";
import { Tag, Tooltip, Typography } from "antd";
import { STANDARD_COST_TYPE_OPTIONS } from "../../../settlement/constants";

const { Text } = Typography;

const COST_TYPE_COLORS = {
    GROUND_HANDLING: "blue",
    FUEL: "orange",
    NAVIGATION: "green",
    LANDING: "purple",
    PARKING: "cyan",
    DEICING: "magenta",
    CATERING: "red",
    HOTEL: "gold",
    TRANSPORTATION: "lime",
    OTHER: "default",
};

export const getCostTypeColor = (costType) => COST_TYPE_COLORS[costType] || "default";

export const getCostTypeName = (costType) => {
    const option = STANDARD_COST_TYPE_OPTIONS.find((item) => item.value === costType);
    return option ? option.label : costType;
};

export const getUnitDisplay = (unitCode, unitOptions = []) => {
    const option = unitOptions.find((item) => item.value === unitCode);
    if (!option) return unitCode;
    return option.displayName && option.displayName !== unitCode ? `${option.displayName} (${unitCode})` : unitCode;
};

const normalizeText = (value) => String(value ?? "").trim();
const normalizeAirport = (value) => normalizeText(value).toUpperCase();

export const buildProductGridColumns = ({ unitOptions = [], unitsLoading = false } = {}) => [
    {
        key: "product_code",
        name: "产品代码",
        width: 180,
        minWidth: 150,
        editorType: "text",
        editorMinWidth: 240,
        placeholder: "如 transit_clean_b747",
        normalize: normalizeText,
        renderValue: (value) => (value ? <Text code>{value}</Text> : <Text type="secondary">未填写</Text>),
    },
    {
        key: "name",
        name: "产品名称",
        width: 220,
        minWidth: 180,
        editorType: "text",
        editorMinWidth: 280,
        placeholder: "如 Full Transit Cleaning B747",
        normalize: normalizeText,
    },
    {
        key: "cost_type",
        name: "费用类型",
        width: 160,
        minWidth: 140,
        editorType: "select",
        options: STANDARD_COST_TYPE_OPTIONS,
        renderValue: (value) => (value ? <Tag color={getCostTypeColor(value)}>{getCostTypeName(value)}</Tag> : <Text type="secondary">未选择</Text>),
        copyFormatter: (value) => getCostTypeName(value) || "",
    },
    {
        key: "unit",
        name: "单位",
        width: 150,
        minWidth: 120,
        editorType: "select",
        options: unitOptions,
        loading: unitsLoading,
        placeholder: unitOptions.length > 0 ? "请选择单位" : "请先配置单位",
        renderValue: (value) => (value ? <Tag color="geekblue">{getUnitDisplay(value, unitOptions)}</Tag> : <Text type="secondary">未选择</Text>),
        copyFormatter: (value) => getUnitDisplay(value, unitOptions) || "",
    },
    {
        key: "recognition_hints",
        name: "识别提示",
        width: 360,
        minWidth: 260,
        editorType: "textarea",
        editorMinWidth: 460,
        placeholder: "用于 AI 识别账单中产品的提示词",
        normalize: normalizeText,
        renderValue: (value) => (
            value ? (
                <Tooltip title={value} placement="topLeft">
                    <span>{value}</span>
                </Tooltip>
            ) : <Text type="secondary">未填写</Text>
        ),
    },
    {
        key: "airport_iata_code",
        name: "机场",
        width: 96,
        minWidth: 84,
        editorType: "text",
        editorMinWidth: 120,
        placeholder: "可选",
        normalize: normalizeAirport,
        renderValue: (value) => (value ? <Tag>{value}</Tag> : <Text type="secondary">-</Text>),
    },
];
